module.exports = __webpack_public_path__ + "static/media/4.7.74f992c3.png";